import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'notification-switch',
  standalone: true,
    imports: [
        NgClass
    ],
  templateUrl: './notification-switch.component.html',
  styleUrl: './notification-switch.component.scss'
})
export class NotificationSwitchComponent {
    @Input({ required: true }) isActive: boolean;
}
